var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3877 11.692H9.5752V12.5045H2.87207V4.17639H3.68457V3.36389H2.05957V13.317H10.3877V11.692Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3877 1.12952V10.8795H11.5127V4.6175L8.02471 1.12952H3.3877ZM10.7002 10.067H4.2002V1.94202H6.84082V5.80139H10.7002V10.067ZM10.7002 4.98889H7.65332V1.94202H7.68816L10.7002 4.95403V4.98889Z",
    fill: "#1E293B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.0283203 0.723267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.f4774f9c7ace008bef65e9ad9bf9dd63.svg";
export { ForwardRef as ReactComponent };